module.exports = __webpack_public_path__ + "static/media/meeting.80f20cdd.jpg";